import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Funci�n para crear part�culas flotantes - N�mero 5 (m�s part�culas, m�s intensidad)
function createFloatingParticles() {
  const bg = document.getElementById('animatedBg');
  console.log ("entrando a la funcion js de animacion");

  // Verificar que el elemento existe antes de continuar
  if (!bg) {
    console.warn('Elemento con ID "animatedBg" no encontrado');
    return;
  }
  
  const particleCount = 50; // Aumentado de 25 a 50
  
  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    particle.className = 'floating-particle';
    
    // Posici�n aleatoria
    particle.style.left = Math.random() * 100 + '%';
    particle.style.top = Math.random() * 100 + '%';
    
    // Delay aleatorio para la animaci�n
    particle.style.animationDelay = Math.random() * 4 + 's';
    
    // Duraci�n aleatoria m�s r�pida
    particle.style.animationDuration = (2 + Math.random() * 3) + 's';
    
    bg.appendChild(particle);
  }
  
  // Crear part�culas adicionales cada cierto tiempo para m�s dinamismo
  setInterval(() => {
    if (bg.children.length < 75) {
      const particle = document.createElement('div');
      particle.className = 'floating-particle';
      particle.style.left = Math.random() * 100 + '%';
      particle.style.top = Math.random() * 100 + '%';
      particle.style.animationDelay = '0s';
      particle.style.animationDuration = (2 + Math.random() * 3) + 's';
      bg.appendChild(particle);
    }
  }, 3000);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
